import DASHBOARD_ROUTES from '@/presentation/modules/dashboard/constants/routes/index';

const dashboardRoutes = [
	{
		name: DASHBOARD_ROUTES.root.name,
		path: DASHBOARD_ROUTES.root.path,
		redirect: DASHBOARD_ROUTES.root.redirect,
		meta: DASHBOARD_ROUTES.root.meta,
		component: DASHBOARD_ROUTES.root.component,
		children: [
			{
				name: DASHBOARD_ROUTES.indexDashboard.name,
				path: DASHBOARD_ROUTES.indexDashboard.path,
				component: DASHBOARD_ROUTES.indexDashboard.component,
			},
			{
				name: DASHBOARD_ROUTES.wallet.name,
				path: DASHBOARD_ROUTES.wallet.path,
				meta: DASHBOARD_ROUTES.wallet.meta,
				component: DASHBOARD_ROUTES.wallet.component,
			},
			{
				name: DASHBOARD_ROUTES.settingRoot.name,
				path: DASHBOARD_ROUTES.settingRoot.path,
				component: DASHBOARD_ROUTES.settingRoot.component,
				children: [
					{
						name: DASHBOARD_ROUTES.setting.name,
						path: DASHBOARD_ROUTES.setting.path,
						component: DASHBOARD_ROUTES.setting.component,
					},
					{
						name: DASHBOARD_ROUTES.identityInformation.name,
						path: DASHBOARD_ROUTES.identityInformation.path,
						meta: DASHBOARD_ROUTES.identityInformation.meta,
						component: DASHBOARD_ROUTES.identityInformation.component,
					},
					{
						name: DASHBOARD_ROUTES.messageManager.name,
						path: DASHBOARD_ROUTES.messageManager.path,
						meta: DASHBOARD_ROUTES.messageManager.meta,
						component: DASHBOARD_ROUTES.messageManager.component,
					},
					{
						name: DASHBOARD_ROUTES.category.name,
						path: DASHBOARD_ROUTES.category.path,
						meta: DASHBOARD_ROUTES.category.meta,
						component: DASHBOARD_ROUTES.category.component,
					},
					{
						name: DASHBOARD_ROUTES.artists.name,
						path: DASHBOARD_ROUTES.artists.path,
						meta: DASHBOARD_ROUTES.artists.meta,
						component: DASHBOARD_ROUTES.artists.component,
					},
					{
						name: DASHBOARD_ROUTES.services.name,
						path: DASHBOARD_ROUTES.services.path,
						meta: DASHBOARD_ROUTES.services.meta,
						component: DASHBOARD_ROUTES.services.component,
					},
					{
						name: DASHBOARD_ROUTES.sendSms.name,
						path: DASHBOARD_ROUTES.sendSms.path,
						meta: DASHBOARD_ROUTES.sendSms.meta,
						component: DASHBOARD_ROUTES.sendSms.component,
					},
				],
			},
			{
				name: DASHBOARD_ROUTES.requestRoot.name,
				path: DASHBOARD_ROUTES.requestRoot.path,
				component: DASHBOARD_ROUTES.requestRoot.component,
				meta: DASHBOARD_ROUTES.requestRoot.meta,
				children: [
					{
						name: DASHBOARD_ROUTES.request.name,
						path: DASHBOARD_ROUTES.request.path,
						component: DASHBOARD_ROUTES.request.component,
					},
					{
						name: DASHBOARD_ROUTES.receiveRequests.name,
						path: DASHBOARD_ROUTES.receiveRequests.path,
						component: DASHBOARD_ROUTES.receiveRequests.component,
					},
					{
						name: DASHBOARD_ROUTES.sendRequests.name,
						path: DASHBOARD_ROUTES.sendRequests.path,
						component: DASHBOARD_ROUTES.sendRequests.component,
					},
					{
						name: DASHBOARD_ROUTES.bookAppointment.name,
						path: DASHBOARD_ROUTES.bookAppointment.path,
						meta: DASHBOARD_ROUTES.bookAppointment.meta,
						component: DASHBOARD_ROUTES.bookAppointment.component,
					},
				],
			},
			{
				name: DASHBOARD_ROUTES.adminRoot.name,
				path: DASHBOARD_ROUTES.adminRoot.path,
				component: DASHBOARD_ROUTES.adminRoot.component,
				children: [
					{
						name: DASHBOARD_ROUTES.adminIndex.name,
						path: DASHBOARD_ROUTES.adminIndex.path,
						meta: DASHBOARD_ROUTES.adminIndex.meta,
						component: DASHBOARD_ROUTES.adminIndex.component,
					},
					{
						name: DASHBOARD_ROUTES.adminBusiness.name,
						path: DASHBOARD_ROUTES.adminBusiness.path,
						meta: DASHBOARD_ROUTES.adminBusiness.meta,
						component: DASHBOARD_ROUTES.adminBusiness.component,
					},
				],
			},
			{
				name: DASHBOARD_ROUTES.creditCharge.name,
				path: DASHBOARD_ROUTES.creditCharge.path,
				meta: DASHBOARD_ROUTES.creditCharge.meta,
				component: DASHBOARD_ROUTES.creditCharge.component,
			},
		],
	},
];

export default dashboardRoutes;
